// ===============================================================
// ---------------------------------------------------------------
// Dependencies
import { useEffect, useContext, Fragment, Suspense, lazy } from "react"

// Context
import AppContext from "../../Context/App/appContext"
import AppNavbar from "../Modules/AppNavbar"

// Modules
import Spinner from "../Modules/Spinner"
import Theme from "../Modules/Theme"
import KnectMobileShowcase from "../Modules/KnectMobileShowcase"
import KnectMobileSteps from "../Modules/KnectMobileSteps"
import StuckSixty60 from "../Modules/StuckSixty60"

// Lazy Modules
const Footer = lazy(() => import("../Modules/Footer"))

// ===============================================================
const KnectMobile = () => {
	// ---------------------------------------------------------------
	// Context
	const appContext = useContext(AppContext)
	const { business, getBusiness } = appContext

	// ---------------------------------------------------------------
	// Scroll to top on load and fetch content
	useEffect(() => {
		window.scrollTo(0, 0)
		getBusiness()
		// eslint-disable-next-line
	}, [])

	return (
			<Suspense fallback={<Spinner />}>
				{business ? (
					<Theme id="knect-mobile" className="knect-mobile">
						<AppNavbar />
						<KnectMobileShowcase />
						<KnectMobileSteps />
                        <StuckSixty60 />
						<Footer />
					</Theme>
				) : (
					<Spinner />
				)}
			</Suspense>
	)
}

export default KnectMobile
